export enum DailyRewardType {
  Gems = 'gems',
  Gift = 'gift',
  EnergyRecharge = 'energy-recharge',
  Ticket = 'ticket',
}

export enum DailyRewardGiftType {
  Ticket = 'ticket',
  PersonalPromocode = 'personal-promocode',
  GeneralPromocode = 'general-promocode',
  Story = 'story',
  External = 'external', // macamp
  Target = 'target',
  Cashback = 'cashback',
}
